<main>
  <div class="page-container">
    <!-- LEFT COLUMN -->
    <div class="column left" *ngIf="deviceInfo.deviceTypeDetected === 'DESKTOP'">
      <div class="texts-container">
        <h1 class="main-title-text" [innerHTML]="'LOGIN_PAGE.MAIN_TITLE' | translate" #mainTitleText></h1>
        <h2 class="subtitle-text" [innerHTML]="'LOGIN_PAGE.SUBTITLE' | translate"></h2>
      </div>
    </div>

    <!-- RIGHT COLUMN -->
    <ng-container *ngIf="APIAvailable">
      <div class="column right" *ngIf="currentUserLang?.key; else userLangLoader">
        <div class="utils-buttons-wrapper">
          <app-utils-buttons (userLangChanged)="userLangChanged($event)"></app-utils-buttons>
        </div>

        <div class="logo">
          <img src="https://kartapobytu.app/img/logo.png" [alt]="'COMMON.ALTS.LOGO' | translate" />
        </div>

        <!-- FORM -->
        <div class="content-column">
          <div nz-row>
            <div nz-col [nzSpan]="24">
              <div class="form-title">{{ 'LOGIN_PAGE.SIGN_IN' | translate }}</div>
            </div>
          </div>

          <!-- FORM -->
          <form nz-form [formGroup]="loginForm" class="login-form" name="loginForm">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzRequired nzFor="loginEmail">
                {{ 'COMMON.LABEL.EMAIL' | translate }}
              </nz-form-label>
              <nz-form-control [nzSpan]="24">
                <input
                  nz-input
                  required
                  id="loginEmail"
                  name="loginEmail"
                  type="email"
                  formControlName="email"
                  autocomplete="email"
                  placeholder="{{ 'COMMON.PLACEHOLDER.ENTER_EMAIL' | translate }}"
                  (focus)="scrollToInput($event)"
                  [attr.aria-describedby]="
                    loginForm.controls.email.invalid && loginForm.controls.email.touched ? 'emailError' : null
                  "
                  [attr.aria-invalid]="loginForm.controls.email.invalid ? 'true' : null" />
              </nz-form-control>

              <!-- ERROR -->
              <mat-error *ngIf="loginForm.controls.email.invalid && loginForm.controls.email.touched" id="emailError">
                {{ loginForm.controls.email.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzRequired nzFor="loginPassword">
                {{ 'COMMON.LABEL.PASSWORD' | translate }}
              </nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-input-group [nzSuffix]="suffixTemplate">
                  <input
                    nz-input
                    required
                    id="loginPassword"
                    name="loginPassword"
                    [type]="isPasswordVisible ? 'text' : 'password'"
                    formControlName="password"
                    autocomplete="current-password"
                    placeholder="{{ 'COMMON.PLACEHOLDER.ENTER_PASSWORD' | translate }}"
                    (focus)="scrollToInput($event)"
                    [attr.aria-describedby]="
                      loginForm.controls.password.invalid && loginForm.controls.password.touched
                        ? 'passwordError'
                        : null
                    "
                    [attr.aria-invalid]="loginForm.controls.password.invalid ? 'true' : null" />
                </nz-input-group>
                <ng-template #suffixTemplate>
                  <button
                    type="button"
                    class="toggle-password-btn"
                    tabindex="-1"
                    [attr.aria-label]="'LOGIN_PAGE.SHOW_HIDE_PASSWORD' | translate"
                    (click)="isPasswordVisible = !isPasswordVisible">
                    <i nz-icon [nzType]="isPasswordVisible ? 'eye-invisible' : 'eye'"></i>
                  </button>
                </ng-template>
              </nz-form-control>

              <!-- ERROR -->
              <mat-error
                *ngIf="loginForm.controls.password.invalid && loginForm.controls.password.touched"
                id="passwordError">
                {{ loginForm.controls.password.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </nz-form-item>

            <!-- Submit button -->
            <div nz-row *ngIf="deviceInfo.deviceTypeDetected === 'DESKTOP' || (loading$ | async) === false">
              <div nz-col [nzSpan]="24">
                <button
                  (click)="submitLoginForm()"
                  class="submit-button"
                  [disabled]="loginForm.pristine || (loginForm.dirty && loginForm.invalid) || (loading$ | async)"
                  mat-raised-button
                  color="primary">
                  {{ 'LOGIN_PAGE.SIGN_IN' | translate }}
                </button>
              </div>
            </div>

            <!-- Mobile spinner -->
            <div
              *ngIf="(loading$ | async) && deviceInfo.deviceTypeDetected !== 'DESKTOP'"
              class="loading-container"
              role="status"
              aria-live="polite">
              <span class="sr-only">
                {{ 'COMMON.LAYOUT.LOADING' | translate }}
              </span>

              <mat-spinner [diameter]="50" [strokeWidth]="3" [attr.aria-hidden]="true"></mat-spinner>
            </div>

            <!-- Errors -->
            <div class="error-message-container" *ngIf="errorMessage$ | async as errorMessage" role="alert">
              <p>{{ errorMessage | translate }}</p>
            </div>

            <!-- Reset password link -->
            <div nz-row *ngIf="deviceInfo.deviceTypeDetected === 'DESKTOP' || (loading$ | async) === false">
              <div nz-col [nzSpan]="24">
                <div class="reset-password-link">
                  <a (click)="$event.preventDefault()" [routerLink]="['/reset-password']">
                    {{ 'LOGIN_PAGE.RESET_PASSWORD' | translate }}
                  </a>
                </div>
              </div>
            </div>

            <!-- New account link -->
            <div nz-row *ngIf="deviceInfo.deviceTypeDetected === 'DESKTOP' || (loading$ | async) === false">
              <div nz-col [nzSpan]="24">
                <div class="new-account-link">
                  <a (click)="$event.preventDefault()" [routerLink]="['/new-account']">
                    {{ 'LOGIN_PAGE.NEW_ACCOUNT' | translate }}
                  </a>
                </div>
              </div>
            </div>
          </form>

          <!-- Desktop spinner -->
          <div
            *ngIf="(loading$ | async) && deviceInfo.deviceTypeDetected === 'DESKTOP'"
            class="loading-container"
            role="status"
            aria-live="polite">
            <span class="sr-only">
              {{ 'COMMON.LAYOUT.LOADING' | translate }}
            </span>

            <mat-spinner [diameter]="35" [attr.aria-hidden]="true"></mat-spinner>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!APIAvailable">
      <div class="column right extra-space">
        <div class="utils-buttons-wrapper">
          <app-utils-buttons (userLangChanged)="userLangChanged($event)"></app-utils-buttons>
        </div>
        <div class="content-column extra-space">
          <div class="form-title error-title">
            {{ 'COMMON.ERROR.NO_CONNECTION_WITH_SERVER' | translate }}
          </div>
          <div class="connection-error-block">
            <div class="subtitle" [innerHTML]="'COMMON.ERROR.CONNECTION_ERROR_EXPLANATION' | translate"></div>
            <ul>
              <li [innerHTML]="'COMMON.NOTIFICATION.WAIT_WE_WILL_TRY_TO_RECONNECT' | translate"></li>
              <li [innerHTML]="'COMMON.NOTIFICATION.CHECK_INTERNET_CONNECTION' | translate"></li>
              <li [innerHTML]="'COMMON.NOTIFICATION.CHECK_FIREWALL_SETTINGS' | translate"></li>
              <li [innerHTML]="'COMMON.NOTIFICATION.CONSULT_LOCAL_NETWORK_ADMIN' | translate"></li>
              <li [innerHTML]="'COMMON.NOTIFICATION.COMEBACK_LATER' | translate"></li>
            </ul>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <ng-template #userLangLoader>
    <div class="column right" role="status" aria-live="polite">
      <span class="sr-only">
        {{ 'COMMON.LAYOUT.LOADING' | translate }}
      </span>

      <mat-spinner [diameter]="40" [attr.aria-hidden]="true"></mat-spinner>
    </div>
  </ng-template>

  <div
    #safeLogoutInfoRef
    *ngIf="safeLogoutInfo && currentUserLang?.key"
    role="dialog"
    aria-modal="true"
    class="safe-logout-info"
    (click)="safeLogoutInfo = false; $event.stopPropagation(); $event.preventDefault()"
    (keydown.escape)="safeLogoutInfo = false"
    tabindex="0">
    <h2 [innerHTML]="'LOGIN_PAGE.YOU_HAVE_BEEN_SAFELY_LOGGED_OUT' | translate"></h2>
  </div>
</main>
